export enum ShippingConditionEnum {
  PickUp = '02',
  Standard = '01',
}
